import React from 'react';
import PropTypes from 'prop-types';
import { useColors } from '../../../hooks/useColors';

/**
 * Badge component for displaying status labels, counts, or other highlights
 * Uses semantic color classes from shared configuration
 */
export const Badge = ({ children, variant = 'default', className = '', ...props }) => {
  const colors = useColors();
  const semantic = colors.semantic;

  const variantClasses = {
    default: `${semantic.contentCardBg} ${semantic.contentCardText}`,
    primary: 'bg-primary-100 dark:bg-primary-900/20 text-primary-700 dark:text-primary-300',
    accent: 'bg-accent-100 dark:bg-accent-900/20 text-accent-700 dark:text-accent-300',
    success: 'bg-green-100 dark:bg-green-900/20 text-green-700 dark:text-green-300',
    warning: 'bg-yellow-100 dark:bg-yellow-900/20 text-yellow-700 dark:text-yellow-300',
    danger: 'bg-red-100 dark:bg-red-900/20 text-red-700 dark:text-red-300',
  };

  return (
    <span 
      className={`inline-flex items-center justify-center px-2.5 py-0.5 text-xs font-medium rounded-full ${variantClasses[variant]} ${className}`} 
      {...props}
    >
      {children}
    </span>
  );
};

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['default', 'primary', 'accent', 'success', 'warning', 'danger']),
  className: PropTypes.string
};

export default Badge;

